window.addEventListener('load', function () {
    //Récupérer le form (js-soumission-formulaire-ajax)
    let formulaire = document.querySelector('.formulaire-wrapper .js-soumission-formulaire-ajax');

    if(formulaire != null) {
        formulaire.addEventListener('submit', function (event) {
            event.preventDefault();
            const formulaireCourant = event.currentTarget;
            const adminAjaxUrl = formulaireCourant.getAttribute('data-admin-ajax-url');

            //Appel Ajax WordPress
            const data = new FormData(formulaireCourant);//Récupération des données du formulaire
            //Définition de l'action à déclencher (ajax_send_contact_form est défini dans Bootstrap.php)
            //data.append('action', formulaireCourant.getAttribute('data-action'));
            //data.append('nonce', formulaireCourant.getAttribute('data-nonce'));

            //Pour les champs avec umask, supprimer les caractères du mask
            if(data.has('company_identification') && data.get('company_identification').includes('_')) {
                data.set('company_identification', data.get('company_identification').replaceAll('_', '').trim());
            }
            if(data.has('phone') && data.get('phone').includes('_')) {
                data.set('phone', data.get('phone').replaceAll('_', '').trim());
            }

            const formulaireCourantContenuElement = formulaireCourant.querySelector('.formulaire-contenu');
            const formulaireCourantErreurElement = formulaireCourant.querySelector('.formulaire-validation-erreur');
            const formulaireCourantSuccesElement = formulaireCourant.querySelector('.formulaire-validation-succes');

            //Récupérer l'URL de redirection (où rediriger si le formulaire a été soumis avec succès et à partir d'un data attribut sur le formulaire)
            let urlRedirectionSucces = '';
            if(formulaireCourant.getAttribute('data-redirection-url-succes')) {
                urlRedirectionSucces = formulaireCourant.getAttribute('data-redirection-url-succes');
            }

            //Définir si on doit laisser le formulaire afficher (en cas de succes) (à partir d'un data attribut sur le formulaire)
            let laisserFormulaireAffiche = false;
            if(formulaireCourant.getAttribute('data-laisser-formulaire-ouvert') && formulaireCourant.getAttribute('data-laisser-formulaire-ouvert') === 'oui') {
                laisserFormulaireAffiche = true;
            }

            //Masquer le message de succès (si le formulaire a été soumis avec succès et est à nouveau soumis)
            if(!formulaireCourantContenuElement.classList.contains('d-none') && laisserFormulaireAffiche) {
                formulaireCourantSuccesElement.classList.add('d-none');
            }

            //Vider les messages d'erreur (div)
            let affichageErreurElements = document.querySelectorAll('.formulaire-champ-erreur');
            if (affichageErreurElements != null && affichageErreurElements.length > 0) {
                affichageErreurElements.forEach(function (affichageErreurElement) {
                    affichageErreurElement.textContent = '';
                });
            }

            fetch(adminAjaxUrl, {
                method: "POST",
                body: data
            })
                .then(response => response.json())
                .then(json => {
                    if (json['success']) {
                        //Masquer le message d'erreur (s'il est affiché)
                        if (!formulaireCourantErreurElement.classList.contains('d-none')) {
                            formulaireCourantErreurElement.classList.add('d-none');
                        }

                        //Afficher le message de succès
                        formulaireCourantSuccesElement.classList.remove('d-none');

                        if(!laisserFormulaireAffiche) {
                            //Masquer le formulaire (s'il ne doit pas rester affiché)
                            formulaireCourantContenuElement.classList.add('d-none');
                        }

                        //S'il y a une URL de redirection, rediriger vers cette URL
                        if(urlRedirectionSucces !== '') {
                            window.location.href = urlRedirectionSucces;
                        }
                    } else {
                        if (json['data'] != null && json['data'] instanceof String) {
                            formulaireCourantErreurElement.querySelector('p').textContent = json['data'];
                        }
                        //Pour chaque "messages" renvoyés par l'API : Afficher le message par champ (propertyPath et title)
                        if (json['data'] != null && json['data']['messages'] != null) {
                            json['data']['messages'].forEach(function (message) {
                                let champAvecErreur = document.getElementById(message['propertyPath']);
                                if (champAvecErreur != null) {
                                    let parentChampAvecErreur = null;
                                    if(champAvecErreur.parentElement.querySelector('.formulaire-champ-erreur') != null) {
                                        parentChampAvecErreur = champAvecErreur.parentElement;
                                    }else if(champAvecErreur.parentElement.parentElement.querySelector('.formulaire-champ-erreur') != null) {
                                        parentChampAvecErreur = champAvecErreur.parentElement.parentElement;
                                    }
                                    if (parentChampAvecErreur != null) {
                                        parentChampAvecErreur.querySelector('.formulaire-champ-erreur').textContent += message['title'] + ' ';
                                    }
                                }
                            });
                        }
                        //Afficher le message d'erreur (s'il n'est pas affiché)
                        if (formulaireCourantErreurElement.classList.contains('d-none')) {
                            formulaireCourantErreurElement.classList.remove('d-none');
                        }
                    }
                });
        });
    }
});